import { LINE_CONTAINER_TAG_NAME } from './create'

export function getRange() {
  const selection = document.getSelection()
  if (selection?.rangeCount === 0) return null

  return selection?.getRangeAt(0)
}

export function getCaretContainingLineNode(range: Range) {
  const ancestorNode = range.commonAncestorContainer
  const ancestorName = ancestorNode.nodeName

  if (ancestorName === 'DIV' || ancestorName === LINE_CONTAINER_TAG_NAME)
    return ancestorNode

  if (ancestorName === '#text') return ancestorNode.parentElement
  return null
}

export function getTextBeforeCaret(): string {
  const range = getRange()
  if (!range) return ''

  const { startOffset } = range
  if (startOffset === 0) return ''

  const nodeValueBeforeCaret = range.startContainer.nodeValue?.slice(
    0,
    range.startOffset,
  )
  if (!nodeValueBeforeCaret) return ''

  const lastSpaceIndex = Math.max(
    nodeValueBeforeCaret.lastIndexOf(' '),
    nodeValueBeforeCaret.lastIndexOf(String.fromCharCode(160)),
  )

  return lastSpaceIndex < 0
    ? nodeValueBeforeCaret
    : nodeValueBeforeCaret.slice(lastSpaceIndex + 1)
}

export function shouldConsiderEmpty(editorElement: HTMLDivElement) {
  const innerHTML = editorElement?.innerHTML
  return innerHTML === '' || innerHTML === '<br>'
}

export function getLastMentionCharIndexBeforeCaret() {
  const range = getRange()
  if (!range) return -1

  const { startOffset } = range
  if (startOffset === 0) return -1

  const startNodeValue = range.startContainer.nodeValue
  return startNodeValue.slice(0, startOffset).lastIndexOf('@')
}

export function removeSpansAndDivs(editorElement: HTMLDivElement) {
  const range = getRange()
  const { startOffset, endOffset, startContainer, endContainer } = range || {}

  let rangeStartSpan: HTMLSpanElement
  let rangeEndSpan: HTMLSpanElement
  let newRangeStartText: Node
  let newRangeEndText: Node

  if (range) {
    if (startContainer.parentElement.nodeName === 'SPAN')
      rangeStartSpan = startContainer.parentElement

    if (endContainer.parentElement.nodeName === 'SPAN')
      rangeEndSpan = startContainer.parentElement
  }

  editorElement.childNodes.forEach(node => {
    if (node.nodeName === 'SPAN' || node.nodeName === 'DIV') {
      const textNode = document.createTextNode(node.textContent)
      if (node === rangeStartSpan) newRangeStartText = textNode
      if (node === rangeEndSpan) newRangeEndText = textNode

      editorElement.replaceChild(textNode, node)
    }
  })

  if (range && (newRangeStartText || newRangeEndText)) {
    range.setStart(newRangeStartText, startOffset)
    range.setEnd(newRangeEndText, endOffset)
  }
}

export function putCaretAtEndOfEditor(editorElement: HTMLDivElement) {
  const range = document.createRange()
  range.selectNodeContents(editorElement)
  range.collapse()
  refreshRange(range)
}

export function refreshRange(range: Range) {
  const selection = document.getSelection()
  selection.removeAllRanges()
  selection.addRange(range)
}

export function scrollToCursor() {
  const range = getRange()
  if (range.commonAncestorContainer === document) return

  const tempAnchorEl = document.createElement('br')
  range.insertNode(tempAnchorEl)

  tempAnchorEl.scrollIntoView({
    block: 'end',
  })
  tempAnchorEl.remove()
}
